module.exports = __webpack_public_path__ + "static/media/calendar.e0aaae8b.svg";